<template>
    <div>
        <div class="passwordBox animated fadeInDown">
            <div class="row">
                <div class="col">
                    <div class="ibox-content sombra">
                        <div class="row">
                            <div class="col text-center">
                                <img :src="logo" class="img-fluid" alt="Logo">
                            </div>
                        </div>
                        <form @submit.prevent="envia_codigo" v-if="!enviado">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Autenticacion de 2 Factores. Seleccione Metodo</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-addon"><i class="fal fa-envelope"></i> </span>
                                            </div>
                                            <select class="custom-select" v-model="tipo">
                                                <option disabled value="">Seleccione</option>
                                                <option value="Email" v-if="canal_2fa_email == 1">
                                                    Correo: {{email}}
                                                </option>
                                                <option value="Telefono" v-if="canal_2fa_telefono == 1">
                                                    Telefono: {{telefono}}
                                                </option>
                                            </select>
                                            <!-- <span class="invalid-feedback" role="alert" v-if="error">
                                            <strong>{{ message }}</strong>
                                        </span> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <button class="btn btn-primary" :disabled="disable">Enviar</button>
                                </div>
                            </div>
                        </form>
                        <form @submit.prevent="verifica_codigo" v-if="enviado">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>ingresa el Codigo</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-addon"><i class="fal fa-envelope"></i> </span>
                                            </div>
                                            <input class="form-control " placeholder="Codigo" type="text" v-model="codigo">
                                            <!-- <span class="invalid-feedback" role="alert" v-if="error">
                                            <strong>{{ message }}</strong>
                                        </span> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <button class="btn btn-primary" type="submit">Verificar</button>
                                    <div v-if="!volver_a_enviar">Volver a enviar en {{minutos}}:{{segundos < 10 ? "0"+segundos : segundos}}</div>
                                    <button v-if="volver_a_enviar" class="btn btn-primary" @click="resend">Volver a enviar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "TwoFactor",
    props: ['logo', 'email', 'telefono' ,'canal_2fa_email', 'canal_2fa_telefono'],
    data: function() {
        return {
            tipo: "",
            enviado: false,
            codigo: "",
            disable: false,
            minutos: 2,
            segundos: 60,
            volver_a_enviar: false,
            interval: null
        };
    },
    methods: {
        envia_codigo() {
            if (this.tipo == "") {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Elija una opcion',
                    showConfirmButton: true,
                    timer: 1000,
                });
                return;
            }
            this.disable = true
            axios.post('', { tipo: this.tipo }).then(response => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Enviado',
                    text: 'Se ha enviado un codigo a tu ' + this.tipo,
                    showConfirmButton: true,
                    timer: 1000,
                });
                this.enviado = true;
                this.volver_a_enviar = false
                this.interval = setInterval(() => {
                    // console.log("ENTRE");

                    if(this.segundos == 0){
                        if(this.minutos == 0){
                            this.volver_a_enviar = true;
                            this.segundos = 60;
                            this.minutos = 2;
                            clearInterval(this.interval);
                        }
                        this.segundos = 60;
                        this.minutos--;
                    }
                    this.segundos = this.segundos - 1;
                }, 1000);
            }).catch(error => {
                this.disable = false

                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ha ocurrido un error',
                    showConfirmButton: true,
                    timer: 1000,
                });
            });
        },
        verifica_codigo() {
            if (this.codigo == "") {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ingrese Codigo',
                    showConfirmButton: true,
                    timer: 1000,
                });
                return;
            }
            axios.post('validaCodigo', { codigo: this.codigo }).then(response => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Enviado',
                    text: 'Codigo Validado Correctamente',
                    showConfirmButton: true,
                    timer: 1000,
                });
                window.location.href = '/admin';
            }).catch(error => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El codigo no coincide',
                    showConfirmButton: true,
                    timer: 1000,
                });
            })
        },
        resend() {
            this.enviado = false;
            this.disable = false;
            axios.post('resendCode').then(response=>{

            }).catch(error=>{
                console.log("HA OCURRIDO UN ERROR");
            })
        }
    },
};
</script>
